import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <span className="site-footer__brand">
          <i className="fa-solid fa-utensils" aria-hidden="true" />
          Kozhikode Food Map
        </span>
        <nav className="site-footer__links" aria-label="Footer">
          <a href="#results">Browse spots</a>
          <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
            Map data
          </a>
          <a href="#top">Back to top</a>
        </nav>
        <p className="site-footer__note">
          A community-curated food guide for Calicut, Kerala. Spots are
          approximate. Call ahead or check current hours before you go.
        </p>
      </div>
    </footer>
  );
};

export default Footer;